import React from 'react';
import MediaQuery from 'react-responsive';

import { fetchTeam } from '../../helpers/DataProvider';
import TeamMemberCard from './teamMemberCard/TeamMemberCard';
import clevelsCardRight from './cLevels/cLevelsCardRight.module.css';
import clevelsCardLeft from './cLevels/cLevelsCardLeft.module.css';

import fotoVt from '../../images/about/vt.jpg';
import fotoDani from '../../images/about/dani.jpg';
import fotoJessica from '../../images/about/jessica.jpg';
import fotoMaria from '../../images/about/maria.jpg';
import fotoJoma from '../../images/about/joma.jpg';
import linkedin from '../../images/about/linkedin_logo.png';

import './Team.css';

/* conectou a parte de lideranca com as imagenzinhas existentes */

class TeamSection extends React.Component {
  constructor() {
    super();

    this.state = {
      team: [],
      selectedMember: null,
      selectionLocked: false,
    };
  }

  componentDidMount() {
    document.addEventListener('click', () => {
      this.setState({
        selectionLocked: false,
      });
    });

    fetchTeam((team) => {
      this.setState({
        team,
        selectedMember: team[0],
      });
    });
  }

  selectMember(member, event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    const { selectedMember, selectionLocked } = this.state;
    let lockSelection = true;

    if (selectedMember === member && selectionLocked) {
      lockSelection = false;
    }

    this.setState({
      selectedMember: member,
      selectionLocked: lockSelection,
    });
  }

  hoverMember(member) {
    const { selectionLocked } = this.state;

    if (!selectionLocked) {
      this.setState({
        selectedMember: member,
      });
    }
  }

  render() {
    const { team, selectedMember, selectionLocked } = this.state;

    return (
      <div id="team">
        <div className="top-portion">
          <h4 className="SectionTitle">Nosso time</h4>
          <div className="separator" />
        </div>

        <div className="lideranca">
          <h1>Liderança</h1>
          <div className="linhaBottomLideranca">
            <i className="linha" />
          </div>
        </div>

        <div id="linha_grid">
          <i className="linhacLevel" />
        </div>

        <div id="cLevelsList">

          {/* VT */}
          <div className="cLevelRight">
            <div className={clevelsCardRight.cLevel}>
              <div className={clevelsCardRight.cLevelsText}>
                <h1 className={clevelsCardRight.cLevelsName}>
                  Veronica Teichrieb
                </h1>
                <h2 className={clevelsCardRight.cLevelsFunction}>
                  Diretora (CEO)
                </h2>
                <h4 className={clevelsCardRight.cLevelsEmail}>
                  vt@cin.ufpe.br
                </h4>
                <a className="sec_linkedinDir" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/veronica-teichrieb-aa4524185/">
                  <img className="logo_linkedinDir" src={linkedin} alt="" />
                </a>
                <h3 className={clevelsCardRight.cLevelsDescription}>
                  Diretora Líder da área de ciência do Voxar Labs; coordenando processos que
                  envolvem pesquisa aplicada à inovação e perspectiva científica em projetos
                  guiados pelo foresight do Voxar Labs.
                </h3>
              </div>
              <div className={clevelsCardRight.cLevelsPhoto}>
                <img src={fotoVt} alt="Foto de Veronica Teichrieb" />
              </div>
            </div>

          </div>

          {/* Dani */}
          <div className="cLevelLeft">
            <div className={clevelsCardLeft.cLevel}>
              <div className={clevelsCardLeft.photo}>
                <img src={fotoDani} alt="Foto de Veronica Teichrieb" />
              </div>
              <div className={clevelsCardLeft.text}>
                <h1 className={clevelsCardLeft.leftName}>
                  <span className={clevelsCardLeft.name}>Dani Bezerra</span>
                </h1>
                <h2 className={clevelsCardLeft.leftFunction}>
                  <span className={clevelsCardLeft.function}>Chief Business Officer (CBO)</span>
                </h2>
                <h4 className={clevelsCardLeft.leftEmail}>
                  <span className={clevelsCardLeft.email}>dbs2@cin.ufpe.br</span>
                </h4>
                <a className="sec_linkedinEsq" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/dani-bezerra/">
                  <img className="logo_linkedinEsq" src={linkedin} alt="" />
                </a>
                <h3 className={clevelsCardLeft.leftDescription}>
                  <span className={clevelsCardLeft.description}>
                    Responsável pelo relacionamento com clientes,
                    parceiros e startups, pela expansão e identificação de
                    oportunidades de novos negócios e mercados.
                  </span>
                </h3>
              </div>
            </div>

          </div>

          {/* Maria */}
          <div className="cLevelRight">
            <div className={clevelsCardRight.cLevel}>
              <div className={clevelsCardRight.cLevelsText}>
                <h1 className={clevelsCardRight.cLevelsName}>
                  Maria Euzébio
                </h1>
                <h2 className={clevelsCardRight.cLevelsFunction}>
                  Chief Financial Officer (CFO)
                </h2>
                <h4 className={clevelsCardRight.cLevelsEmail}>
                  vt@cin.ufpe.br
                </h4>
                <a className="sec_linkedinDir" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/maria-de-lourdes-timóteo-euzébio-36008538/">
                  <img className="logo_linkedinDir" src={linkedin} alt="" />
                </a>
                <h3 className={clevelsCardRight.cLevelsDescription}>
                Responsável pelas finanças e administração do laboratório;
                coordenando processos financeiros,
                viabilização de projetos e gestão de recursos humanos.
                </h3>
              </div>
              <div className={clevelsCardRight.cLevelsPhoto}>
                <img src={fotoMaria} alt="Foto de Veronica Teichrieb" />
              </div>
            </div>

          </div>

          {/* Jessica */}
          <div className="cLevelLeft">
            <div className={clevelsCardLeft.cLevel}>
              <div className={clevelsCardLeft.photo}>
                <img src={fotoJessica} alt="Foto de Jessica Sena" />
              </div>
              <div className={clevelsCardLeft.text}>
                <h1 className={clevelsCardLeft.leftName}>
                  <span className={clevelsCardLeft.name}>Jéssica Sena</span>
                </h1>
                <h2 className={clevelsCardLeft.leftFunction}>
                  <span className={clevelsCardLeft.function}>Project Management Officer (PMO)</span>
                </h2>
                <h4 className={clevelsCardLeft.leftEmail}>
                  <span className={clevelsCardLeft.email}>jfls2@cin.ufpe.br</span>
                </h4>
                <a className="sec_linkedinEsq" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/jessicasena/">
                  <img className="logo_linkedinEsq" src={linkedin} alt="" />
                </a>
                <h3 className={clevelsCardLeft.leftDescription}>
                  <span className={clevelsCardLeft.description}>
                    Responsável por garantir a entrega de valor de forma
                    recorrente e incremental nos projetos,
                    geração de indicadores para tomadas de
                    decisões e processos de melhoria contínua.
                  </span>
                </h3>
              </div>
            </div>
          </div>

          {/* Joma */}
          <div className="cLevelCenter">
            <div className="cLevelRight">
              <div className={clevelsCardRight.cLevel}>
                <div className={clevelsCardRight.cLevelsText}>
                  <h1 className={clevelsCardRight.cLevelsName}>
                    João Marcelo
                  </h1>
                  <h2 className={clevelsCardRight.cLevelsFunction}>
                    Chief Technology Officer (CTO)
                  </h2>
                  <h4 className={clevelsCardRight.cLevelsEmail}>
                  jmxnt@cin.ufpe.br
                  </h4>
                  <a className="sec_linkedinDir" target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/joão-marcelo-teixeira-a0026139/">
                    <img className="logo_linkedinDir" src={linkedin} alt="linkedin Logo" />
                  </a>
                  <h3 className={clevelsCardRight.cLevelsDescription}>
                    Responsável pelos processos de desenvolvimento e
                    transferência tecnológica no grupo,
                    com o objetivo de otimizar e garantir a
                    qualidade das soluções geradas.
                  </h3>
                </div>
                <div className={clevelsCardRight.cLevelsPhoto}>
                  <img src={fotoJoma} alt="Foto de João Marcelo" />
                </div>
              </div>
            </div>
          </div>

        </div>


        <div id="teamGallery">
          <div id="photos">
            {
              team.map((teamMember) => {
                const isSelected = teamMember === selectedMember;
                const opacity = (!isSelected && selectionLocked) ? '0.5' : '1';

                return (
                  <MediaQuery query="(min-width: 425px)" key={teamMember.email}>
                    {isDesktop => (
                      <div
                        className="collaborator"
                        role="button"
                        tabIndex={0}
                        alt={teamMember.name}
                        style={{
                          opacity,
                        }}
                        onMouseOver={isDesktop ? (() => this.hoverMember(teamMember)) : null}
                        onFocus={isDesktop ? (() => this.hoverMember(teamMember)) : null}
                        onClick={isDesktop ? (event => this.selectMember(teamMember, event)) : null}
                        onKeyPress={isDesktop ? (() => this.selectMember(teamMember)) : null}
                      >
                        <img
                          alt=""
                          src={teamMember.image}
                          onError={(event) => {
                            /* eslint-disable-next-line no-param-reassign */
                            event.target.src = 'img/assets/team/place.jpg';
                          }}
                        />
                        <div className={isDesktop && isSelected ? 'selectMemberBorder' : ''} />
                      </div>
                    )}
                  </MediaQuery>
                );
              })
            }
          </div>
          <MediaQuery query="(min-width: 425px)">
            <div id="memberCard">
              {
                selectedMember && <TeamMemberCard teamMember={selectedMember} />
              }
            </div>
          </MediaQuery>
        </div>
      </div>
    );
  }
}

export default TeamSection;
